var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          pagination: _vm.pagination,
          "select-all": "",
          "item-key": "name"
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  [
                    _vm.selectable
                      ? _c(
                          "th",
                          [
                            _c("v-checkbox", {
                              attrs: {
                                "input-value": props.all,
                                indeterminate: props.indeterminate,
                                primary: "",
                                "hide-details": ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleAll($event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._l(props.headers, function(header) {
                      return _c(
                        "th",
                        {
                          key: header.text,
                          class: [
                            "column sortable",
                            _vm.pagination.descending ? "desc" : "asc",
                            header.value === _vm.pagination.sortBy
                              ? "active"
                              : ""
                          ],
                          on: {
                            click: function($event) {
                              return _vm.changeSort(header.value)
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("arrow_upward")
                          ]),
                          _vm._v(
                            "\n          " + _vm._s(header.text) + "\n        "
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ]
            }
          },
          {
            key: "items",
            fn: function(props) {
              return [
                _vm.selectable
                  ? _c(
                      "tr",
                      {
                        attrs: { active: props.selected },
                        on: {
                          click: function($event) {
                            props.selected = !props.selected
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          [
                            _c("v-checkbox", {
                              attrs: {
                                "input-value": props.selected,
                                primary: "",
                                "hide-details": ""
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(_vm.properties, function(property) {
                          return _c("td", { key: property }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.item[property]) +
                                "\n        "
                            )
                          ])
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "no-data",
            fn: function() {
              return [
                _c("div", { staticClass: "center" }, [
                  _vm._v("\n        " + _vm._s(_vm.noDataMessage) + "\n      ")
                ])
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }